import { render, staticRenderFns } from "./FilterTagsEmployee.vue?vue&type=template&id=e5867ed0&"
import script from "./FilterTagsEmployee.vue?vue&type=script&lang=js&"
export * from "./FilterTagsEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports